import axios from 'axios';
import store from '@/store/Store';

// @ts-ignore
const API_URL = import.meta.env.VITE_API_URL;

export const fetchKalenteriList = async () => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + '/kalenteri/list', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchKalenterinTuotteet = async (id) => {
  const token = store.getState().auth.token;

  if (!token) throw new Error('Not authenticated!');

  const res = await axios.get(API_URL + `/kalenteri/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};

export const fetchTuotteenSaatavuus = async (itemId, month, year) => {
  const token = store.getState().auth.token;
  const yritysId = store.getState().auth.yritysId;
  if (!yritysId) throw new Error('YritysId puuttuu!');

  const alku = new Date(year, month, 1);
  // month + 1 --> ensi kuu, 0 --> edellisen kuun viimeinen päivä
  const loppu = new Date(year, month + 1, 0);

  // Formatoi pvm APIn odottamaan muotoon
  const format = d => `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;

  const hakuaika = `${format(alku)}-${format(loppu)}`;

  const res = await axios.get(API_URL + `/saatavuus/calendar?yritysId=${yritysId}&tuoteId=${itemId}&time=${hakuaika}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (res.data.errorCode) {
    if (res.data.errorCode === 4000) {
      throw new Error('Tuotetyypin kalenteria ei ole saatavilla.');
    }
    else if (res.data.errorCode === 3000) {
      throw new Error('Tuotteen saatavuutta ei voida hakea valitulle ajalle.');
    }

    throw new Error(`Saatavuuden hakeminen epäonnistui: ${res.data.errorDescription}`);
  }

  return res.data;
};
